module.exports = __webpack_public_path__ + "assets/b83.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b83.png
// module id = 675
// module chunks = 0